import styled from "styled-components/macro";
import { BottomSection, ChatBotContent } from "../ChatBot/ChatBot";

export const SearchContent = styled(ChatBotContent)`
  box-sizing: border-box;
  min-height: 0;
  padding: ${({ theme }) => theme.resolve("spacing_xl")};
`;

export const SearchFooter = styled(BottomSection)`
  box-sizing: border-box;
`;
